// Is this Google place already a restaurant on Synvya? Asked by the wizard
// after a search result is picked and before any team is created, so a second
// owner of the same place is told to ask for an invite instead of minting a
// duplicate (2026-09-08). Public route; no session exists yet.

import { serverFetch } from '@/lib/serverFetch'
import { ApiError } from '@/lib/apiError'
import { ensureMerchantSession } from './merchantAuth'
import type { LoyaltyServiceContext } from './loyalty'

export interface RegisteredLookup {
  registered: boolean
  restaurant_pubkey?: string
  name?: string | null
}

/**
 * `null` means the server could not answer (lookup not wired, network down).
 * The wizard treats that as "unknown, go ahead" — a duplicate is a support
 * ticket, a blocked sign-up is a lost restaurant.
 */
export async function lookupRegisteredRestaurant(googlePlaceId: string): Promise<RegisteredLookup | null> {
  try {
    return await serverFetch<RegisteredLookup>(
      `/api/restaurants/lookup?google_place_id=${encodeURIComponent(googlePlaceId)}`,
    )
  } catch {
    return null
  }
}

/**
 * Record the Google place id a restaurant was created from, right after
 * provisioning, so the lookup above answers before the owner ever publishes
 * a profile. Owner-gated; one silent re-authentication on 401.
 */
export async function recordGooglePlaceId(
  ctx: LoyaltyServiceContext,
  googlePlaceId: string,
): Promise<void> {
  const call = () =>
    serverFetch<{ google_place_id: string }>(
      `/api/restaurants/${ctx.restaurantPubkey}/google-place`,
      { method: 'PUT', body: JSON.stringify({ google_place_id: googlePlaceId }) },
    )
  try {
    await call()
  } catch (err) {
    if (!(err instanceof ApiError) || err.code !== 'unauthorized') throw err
    await ensureMerchantSession(ctx.restaurantPubkey, ctx.signAsRestaurant)
    await call()
  }
}
